import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~env';
import { ExerciseStatus, GlobalMemberStatus, InscriptionStatus } from './member-status.model';


const API_URL = environment.projectionApi;

@Injectable({
  providedIn: 'root'
})
export class MemberStatusQueryService {
  constructor(private http: HttpClient) {}

  getMemberStatus(memberId: string, effectiveDate: Date): Observable<GlobalMemberStatus> {
    const endpoint = `${API_URL}/member/${memberId}/memberStatuses/statusEffectiveAt?effectiveDate=${this.formatDate(
      effectiveDate ?? new Date()
    )}`;
    return this.http
      .get<GlobalMemberStatus>(endpoint)
      .pipe(map((res) => this.parseMemberStatus(res)));
  }

  private parseMemberStatus(item: any): GlobalMemberStatus {
    const res = {
      memberId: item.memberId?.value || item.memberId,
      interruptionId: item.interruptionId?.value || item.interruptionId,
      effectiveOn: item.effectiveOn,
      endOn: item.endOn,
      effectiveInscriptionStatus: null,
      effectiveExerciseStatus: null,
      effectiveInsuranceStatus: null
    };

    switch (item.effectiveInscriptionStatus) {
      case 'Registered':
        res.effectiveInscriptionStatus = InscriptionStatus.Registered;
        break;
      case 'NotRegistered':
        res.effectiveInscriptionStatus = InscriptionStatus.NotRegistered;
        break;
      case 'PermanentNotRegistered':
        res.effectiveInscriptionStatus = InscriptionStatus.PermanentNotRegistered;
        break;
      default:
        res.effectiveInscriptionStatus = InscriptionStatus.NotAvailable;
        break;
    }

    res.effectiveExerciseStatus = this.getExerciseStatusFromString(
      item.effectiveExerciseStatus
    );
    res.effectiveInsuranceStatus = this.getExerciseStatusFromString(
      item.effectiveInsuranceStatus
    );
    return res;
  }

  private getExerciseStatusFromString(status: string) {
    switch (status) {
      case 'Active':
        return ExerciseStatus.Active;
      case 'Inactive':
        return ExerciseStatus.Inactive;
      case 'Terminated':
        return ExerciseStatus.Terminated;
        break;
      default:
        return ExerciseStatus.NotAvailable;
    }
  }

  private formatDate(date: Date) {
    let month = '' + (date?.getUTCMonth() + 1);
    let day = '' + date?.getUTCDate();
    const year = date?.getUTCFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }
}
